import HistoryRecord from "@modules/historyRecord"
export default (param,isUser=1)=>{
    let {isShow=true,value,label=value,data,type=1} = param;
    if(isUser){
        HistoryRecord.addHistoryRecord([{
            isUser,
            isShow,
            value,
            label,
            type,
        }])
        return {
            isUser,
            isShow,
            value,
            label,
            type,
        }
    }else{
        data.forEach(element => {
            element.isUser = false;
            //element.isShow = isShow; chatbot信息无是否展示逻辑 
        });
        HistoryRecord.addHistoryRecord(data)
        return data;
    }
}